import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import get from 'lodash.get';

import { noop } from 'ui-components/default-props/noop';

import Global from '../../../store/global-selectors';
import CostReviewLineItemInsuranceHeader from '../../../components/cost-review-line-item/cost-review-line-item-insurance-header';
import CostReviewLineItemBody from '../../../components/cost-review-line-item/cost-review-line-item-body';
import CostReviewLineItemService from '../../../components/cost-review-line-item/cost-review-line-item-service';
import CostReviewLineItemSubtotal from '../../../components/cost-review-line-item/cost-review-line-item-subtotal';
import { CostReviewLineItemPurchaseContainer } from '../../../containers/cost-review/cost-review-line-item-purchase-container';
import { CostReviewHelperService } from '../../../services/cost-review-helper-service';
import { InsuranceProviders } from '../../../enums/insurance-providers';

import style from './cost-review-line-item-insurance.module.less';

const messages = defineMessages({
  insuranceLineItemServiceName: {
    description: 'insuranceLineItemServiceName.serviceName',
    defaultMessage: 'Insurance',
    id: 'iOGt9u',
  },
});

const CostReviewLineItemInsurance = ({
  insuranceProvider,
  onPurchaseAmountChange = noop,
  userHasBillingInfoSetup = false,
  closeOrderDetailsModal = noop,
  closeModal = noop,
  readOnlyCostReviewModal = false,
}) => {
  const userHasPurchasingRole = useSelector(Global.selectUserhasPurchasingRole);

  const { subTotal, insuranceProviderId } = insuranceProvider;

  // This component is only used by insurance providers that are not part of a wallet
  // At time of writing, this was only shipsurance
  // HACK SPD-9694: Shipsurance insuranceProvider id backdoor
  if (insuranceProviderId !== InsuranceProviders.Shipsurance.insuranceProviderId && insuranceProviderId !== '0') {
    return null;
  }

  const balance = get(insuranceProvider, 'balance');
  const currencyCode = CostReviewHelperService.getInsuranceCurrencyCode(insuranceProvider);
  const shouldShowPurchase = !readOnlyCostReviewModal && balance < subTotal;
  const { errorMessage, minPurchaseAmount } = CostReviewHelperService.costReviewLineItemProviderMeta(
    insuranceProvider,
    userHasPurchasingRole,
  );

  return (
    <div className={style.container}>
      <CostReviewLineItemInsuranceHeader balance={balance} balanceCurrencyCode={currencyCode} />
      <CostReviewLineItemBody>
        <CostReviewLineItemService
          serviceCost={subTotal}
          serviceCurrencyCode={currencyCode}
          serviceName={<FormattedMessage {...messages.insuranceLineItemServiceName} />}
        />
      </CostReviewLineItemBody>
      <CostReviewLineItemSubtotal insuranceLineItem subtotal={subTotal} subtotalCurrencyCode={currencyCode} />
      {shouldShowPurchase && (
        <CostReviewLineItemPurchaseContainer
          closeModal={closeModal}
          closeOrderDetailsModal={closeOrderDetailsModal}
          errorMessage={errorMessage}
          minPurchaseAmount={minPurchaseAmount}
          minPurchaseAmountCurrencyCode={currencyCode}
          onPurchaseAmountChange={onPurchaseAmountChange}
          postageCostCurrencyCode={currencyCode}
          provider={insuranceProvider}
          userHasBillingInfoSetup={userHasBillingInfoSetup}
        />
      )}
    </div>
  );
};

CostReviewLineItemInsurance.propTypes = {
  insuranceProvider: PropTypes.object,
  onPurchaseAmountChange: PropTypes.func,
  userHasBillingInfoSetup: PropTypes.bool,
  closeOrderDetailsModal: PropTypes.func,
  closeModal: PropTypes.func,
  readOnlyCostReviewModal: PropTypes.bool,
};

export default CostReviewLineItemInsurance;
